// extracted by mini-css-extract-plugin
var _1 = "TrialUpgradeDisclaimer_tudContainerDesktop__kwTS+";
var _2 = "TrialUpgradeDisclaimer_tudContainerMobile__Iu2NL";
export { _1 as "tudContainerDesktop", _2 as "tudContainerMobile" }
